module.exports = __webpack_public_path__ + "static/media/tm-colorit-11.083bd1a9.webp";